'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function NotFound() {
  const router = useRouter();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      router.push('/');
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(redirectTimer);
    };
  }, [router]);

  return (
    <div className='flex min-h-screen items-center justify-center bg-linear-to-br from-blue-50 to-gray-100'>
      <div className='animate-fadeIn text-center'>
        <Image
          src='/not-found.png'
          alt='404 Illustration'
          width={400}
          height={400}
          className='animate-float mx-auto rounded-lg shadow-xl'
        />

        <h1 className='mt-6 text-7xl font-extrabold text-blue-700'>Looks Like You&apos;re Lost!</h1>
        <p className='mt-2 text-xl text-gray-700'>
          We can&apos;t seem to find the page you&apos;re looking for.
        </p>

        <p className='mt-4 text-sm text-gray-600'>
          Redirecting you to the home page in <span className='font-semibold'>{countdown}</span>{' '}
          seconds...
        </p>

        <div className='mt-6 flex justify-center'>
          <div className='h-12 w-12 animate-spin rounded-full border-4 border-blue-500 border-t-transparent' />
        </div>
      </div>
    </div>
  );
}
